import React, { useState } from "react";
import { ShieldCheck, FileCheck2, Check } from "lucide-react";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";

const CHECKS = {
  developer: {
    label: "Verified Developer",
    icon: ShieldCheck,
    title: "Propera checked this developer's company",
    items: ["Certificate of incorporation", "Company registry record of directors", "Tax registration certificate", "Director's government ID", "Proof of business address"],
  },
  development: {
    label: "Verified Development",
    icon: FileCheck2,
    title: "Propera checked this development's documents",
    items: ["Title deed / land ownership", "Planning permission", "Building approval / permit", "Registered survey plan"],
  },
};

const VARIANTS = {
  solid: "bg-propera text-white",
  overlay: "bg-white/95 text-propera backdrop-blur-md",
  soft: "bg-propera-light text-propera border border-propera/20",
};

export function VerifiedBadge({ kind, variant = "soft", compact = false, testId }) {
  const [open, setOpen] = useState(false);
  const c = CHECKS[kind];
  const Icon = c.icon;
  return (
    <TooltipProvider delayDuration={150}>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <button
            type="button"
            data-testid={testId || `verified-${kind}-badge`}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((v) => !v); }}
            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold cursor-help transition-transform hover:scale-[1.03] ${VARIANTS[variant]}`}
          >
            <Icon size={12} /> {compact ? (kind === "developer" ? "Verified Dev" : "Verified Docs") : c.label}
          </button>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="start" className="max-w-[260px] bg-neutral-900 text-white p-3 rounded-xl" data-testid={`verified-${kind}-tooltip`}>
          <p className="text-xs font-semibold mb-1.5">{c.title}</p>
          <ul className="space-y-1">
            {c.items.map((i) => (
              <li key={i} className="flex items-start gap-1.5 text-[11px] text-white/80"><Check size={11} className="text-emerald-400 mt-0.5 flex-shrink-0" /> {i}</li>
            ))}
          </ul>
          <p className="text-[10px] text-white/50 mt-2">Documents reviewed by the Propera compliance team.</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default function VerifiedBadges({ dev, variant = "soft", compact = false }) {
  if (!dev?.developer_verified && !dev?.docs_verified) return null;
  return (
    <>
      {dev.developer_verified && <VerifiedBadge kind="developer" variant={variant} compact={compact} testId={`verified-developer-badge-${dev.id}`} />}
      {dev.docs_verified && <VerifiedBadge kind="development" variant={variant} compact={compact} testId={`verified-development-badge-${dev.id}`} />}
    </>
  );
}
